import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, DropdownSelector } from 'hyperdb-utils';
import { EntityForm } from '../../../address-book/entity';
import { AVAILABLE_LANGUAGES } from '../../../../../config';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeEntity = this.handleChangeEntity.bind(this);
  }
  render() {
    const entity = this.props.objectData.entity_data || {};
    return (
      <fieldset>
      {/*
        <TextInput
          label="Origin"
          name="origin"
          value={ this.props.objectData.origin }
          onChange={ this.handleChange.bind(this, 'origin') }
        />
      */}
        <DropdownSelector
          label="Language *"
          name="language"
          value={ this.props.objectData.language || '' }
          options={ this.languagesOptions() }
          onChange={ this.handleChange.bind(this, 'language') }
        />
        <TextInput
          label="Passport number"
          name="passport_number"
          value={ this.props.objectData.passport_number }
          onChange={ this.handleChange.bind(this, 'passport_number') }
        />
        <EntityForm entity={ entity } onChange={ this.handleChangeEntity } mode="customer" />
      </fieldset>
    );
  }

  languagesOptions() {
    return AVAILABLE_LANGUAGES.map(language => {
      return { name: language, value: language };
    });
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.customer.updateEditedObject({ attributeName, value });
  }
  handleChangeEntity(attributes) {
    this.handleChange('entity_data', { value: attributes });
    const entity = { ...this.props.objectData.entity };
    entity.value[1] = attributes.id;
    this.handleChange('entity', { value: entity });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/components/Form.jsx